export default __webpack_public_path__ + "static/media/538.89890460.gif";